import { render, staticRenderFns } from "./AsphaltTechnician.vue?vue&type=template&id=24fdb1a2"
import script from "./AsphaltTechnician.vue?vue&type=script&lang=js"
export * from "./AsphaltTechnician.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports